import { images } from "assets";
import type { activityType } from "models/activity.model";
export interface downloadedType {
    data: activityType,
    folderName: string,
}
/**
 * @class Defines an downloadedActivity object.
 */
export class DownloadedActivityModel {
    id: string;
    title: string;
    imageSrc: string;
    offline: boolean;
    
    /**
     * @constructor Creates an instance of an downloadedActivity object built from an original data from the Electron.
     * @param {bo} bo is the basic object come from Electron.
     */
    constructor(bo: downloadedType) {
        this.title = bo.data.title;
        this.id = bo.folderName;
        this.imageSrc = images['activityDefault'];
        this.offline = true;
    }
}

